<template>
  <div class="PaymentMethodRadioButton">
    <el-radio-button :label="value">
      <div class="payment-method-radio-item">
        <div class="label-name">
          {{ name }}
        </div>
      </div>
    </el-radio-button>
  </div>
</template>

<script>
export default {
  name: 'PaymentMethodRadioButton',
  props: {
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    getIcon() {
      return require(`@/assets/images/propTrade/${this.value}.png`);
    }
  }
};
</script>

<style lang="scss" scoped>
.PaymentMethodRadioButton {
  /deep/.el-radio-button.is-active {
    .el-radio-button__inner {
      background: #d9e5ff;
      border-color: $primary-blue;
    }
    .label-name {
      color: $primary-blue;
    }
  }
  /deep/ .el-radio-button__inner {
    background-color: #0051ff0d;
    border-radius: 8px;
    border-color: #0051ff0d;
  }
  .payment-method-radio-item {
    display: flex;
    justify-content: center;
    align-items: center;
    .label-name {
      color: $primary-dark-blue;
      font-size: 14px;
      font-weight: 700;
      @media (max-width: 768px) {
        font-size: 12px;
      }
    }
    .payment-method-icon {
      height: 26px;
    }
  }
}
</style>
